import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Owner PIN is attached to every API request from the owner's device (server checks it on private endpoints).
axios.interceptors.request.use((cfg) => {
  const pin = localStorage.getItem("owner_pin");
  if (pin) cfg.headers = { ...cfg.headers, "X-Owner-Pin": pin };
  return cfg;
});

export const useAccess = () => {
  const { isPro } = useAuth();
  const [owner, setOwner] = useState(!!localStorage.getItem("owner_pin"));
  useEffect(() => { const h = () => setOwner(!!localStorage.getItem("owner_pin")); window.addEventListener("owner-changed", h); return () => window.removeEventListener("owner-changed", h); }, []);
  const [pro, setPro] = useState(false);
  const check = useCallback(async () => {
    const sid = localStorage.getItem("pro_session_id");
    if (!sid) return setPro(false);
    try {
      const { data } = await axios.get(`${API}/pro/status/${sid}`);
      setPro(!!data.pro);
    } catch {
      setPro(false);
    }
  }, []);
  useEffect(() => { check(); }, [check]);

  const login = async (pin) => {
    await axios.post(`${API}/owner/verify`, { pin });
    localStorage.setItem("owner_pin", pin);
    setOwner(true);
    window.dispatchEvent(new Event("owner-changed"));
  };
  const logout = () => { localStorage.removeItem("owner_pin"); setOwner(false); window.dispatchEvent(new Event("owner-changed")); };
  const upgrade = async () => { window.location.href = "/pro"; };
  return { owner, pro: pro || owner || isPro, paidPro: pro || isPro, login, logout, upgrade };
};
